import * as io from 'socket.io-client';

import Environment from '../common/Environment';
import ActivityJson from '../jsons/ActivityJson';

let socket: SocketIOClient.Socket;

const RelayCommunicator = {
  onLoadApp(callbackActions: any) {
    socket = io(Environment.socket());

    socket.on('connected', (data: any) => {
      console.log('PEER ID', data.clientId);
      callbackActions.onConnected();
    });

    socket.on('connect_error', (err: string) => {
      console.log(err);
    });

    socket.on('disconnect', () => {
      console.log('Disconnected Socket!');
    });

    socket.on('activity', (data: ActivityJson) => {
      callbackActions.onActivity(data.activity);
    });
  }
};

export default RelayCommunicator;



// WEBPACK FOOTER //
// ./src/apis/RelayCommunicator.ts